// extracted by mini-css-extract-plugin
module.exports = {"Logos":"styles_Logos__nangx"};